import { isDefined } from '@nordcraft/core/dist/utils/util'
import { getValue, parseMultipleValues } from '../shared'
import type {
  BackgroundPositionType,
  CSSStyleToken,
  NodeTypes,
  ParsedValueType,
} from '../types'
import { parseConicGradient } from './parseConicGradient'
import { parseImageSet } from './parseImageSet'
import { parseLinearGradient } from './parseLinearGradient'
import { parseRadialGradient } from './parseRadialGradient'

export const getParsedValue = (
  property: NodeTypes,
  variables: CSSStyleToken[],
) => {
  const splitValues =
    property.type === 'function' &&
    [
      'linear-gradient',
      'conic-gradient',
      'radial-gradient',
      'repeating-linear-gradient',
      'repeating-conic-gradient',
      'repeating-radial-gradient',
      'image-set',
    ].includes(property.value)

  const splitChuldFuncValues =
    property.type === 'function' && ['image-set'].includes(property.value)

  const propValue = getValue(property, splitValues, splitChuldFuncValues)

  if (propValue.length === 0) {
    return null
  }

  if (propValue[0]?.type === 'function') {
    const parsedValues = parseMultipleValues(propValue)

    if (parsedValues[0]?.type === 'functionArguments') {
      if (
        propValue[0].name === 'linear-gradient' ||
        propValue[0].name === 'repeating-linear-gradient'
      ) {
        return parseLinearGradient(
          parsedValues[0].arguments,
          propValue[0].name,
          variables,
        )
      } else if (
        propValue[0].name === 'conic-gradient' ||
        propValue[0].name === 'repeating-conic-gradient'
      ) {
        return parseConicGradient(
          parsedValues[0].arguments,
          propValue[0].name,
          variables,
        )
      } else if (
        propValue[0].name === 'radial-gradient' ||
        propValue[0].name === 'repeating-radial-gradient'
      ) {
        return parseRadialGradient(
          parsedValues[0].arguments,
          propValue[0].name,
          variables,
        )
      } else if (propValue[0].name === 'image-set') {
        return parseImageSet({ parsedValues, variables })
      } else {
        return parseMultipleValues(propValue)[0] ?? null
      }
    } else {
      return parseMultipleValues(propValue)[0] ?? null
    }
  } else {
    return parseMultipleValues(propValue)[0] ?? null
  }
}

export const getNewPositions = ({
  position,
  previousVal,
  lastPositionVal,
  returnValue,
}: {
  position: BackgroundPositionType | undefined
  previousVal?: ParsedValueType
  lastPositionVal: boolean
  returnValue: ParsedValueType
}) => {
  let newPosition = isDefined(position) ? { ...position } : undefined
  if (!isDefined(newPosition)) {
    newPosition = {
      x: { offset: returnValue },
    }
  } else {
    if (lastPositionVal) {
      if (!isDefined(newPosition.x)) {
        newPosition.x = { offset: returnValue }
      } else if (!isDefined(newPosition.y)) {
        newPosition.y = { offset: returnValue }
      } else if (previousVal?.type !== 'functionArguments') {
        if (
          previousVal?.type === newPosition.x.align?.type &&
          previousVal?.value === newPosition.x.align?.value
        ) {
          newPosition.x = { ...newPosition.x, offset: returnValue }
        } else if (
          previousVal?.type === newPosition.y.align?.type &&
          previousVal?.value === newPosition.y.align?.value
        ) {
          newPosition.y = { ...newPosition.y, offset: returnValue }
        }
      }
    } else {
      if (previousVal?.type !== 'functionArguments') {
        if (
          previousVal?.type === newPosition.x?.align?.type &&
          previousVal?.value === newPosition.x?.align?.value
        ) {
          newPosition.x = { ...newPosition.x, offset: returnValue }
        } else if (
          previousVal?.type === newPosition.y?.align?.type &&
          previousVal?.value === newPosition.y?.align?.value
        ) {
          newPosition.y = { ...newPosition.y, offset: returnValue }
        }
      }
    }
  }

  return newPosition
}
